import { SuspenseLoading } from '@/components/SuspenseErrorBoundary/fallback';
import { useGetAiServiceSetting } from '@/context/services/ai_service_setting/AiServiceSetting.service';
import { FC, Suspense } from 'react';
import { InitialSetting } from './InitialSetting/InitialSetting';
import styles from './styles.module.scss';

export const InnerAiServiceSetting: FC = () => {
  const setting = useGetAiServiceSetting();

  if (setting.is_ai_service_agreed) {
    // TODO: Implement the agreed setting later.
    return null;
  }

  return <InitialSetting services={setting.ai_service_settings} />;
};

export const AiServiceSetting: FC = () => (
  <Suspense fallback={<SuspenseLoading className={styles.loadingContainer} />}>
    <InnerAiServiceSetting />
  </Suspense>
);
